module.exports = __webpack_public_path__ + "static/8-54ce8c17ef1e376b4beeef9af15a0da8.jpg";